import { Button, Space, Table, Tag, Modal, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { getMeals, getUsers, getUser, updateMeals } from '../../service/auth/AuthService';
import { Link, useNavigate } from 'react-router-dom';
import { deleteAccessToken, setAccessToken, setToken, getAccessToken } from '../../helper/tokenHelper';
import { formatMoney } from '../../helper/formatCurrencyHelper';

import moment from 'moment';
import './Home.scss';
interface DataType {
	key: string;
	name: string;
	age: number;
	address: string;
	tags: string[];
}

export default function Home() {
	const navigate = useNavigate();
	const [usersMeal, setUsersMeal] = useState<any>([]);
	const [userRender, setUserRender] = useState<any>([]);
	const [user, setUser] = useState<any>('');
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [infoDeleteMeal, setInfoDeleteMeal] = useState<any>({});

	const fetchAPI = async () => {
		await getUsers()
			.then(res => {
				// console.log(res);
				setUserRender(res.data.data);
			})
			.catch(err => {
				console.log(err);
			});
		await getMeals()
			.then((res: any) => {
				setUsersMeal(res.data.result);
			})
			.catch((err: any) => {
				console.log(err);
			});

		await getUser()
			.then(res => {
				// console.log('res.data.data', res.data.data);
				setUser(res.data.data);
			})
			.catch(err => {
				console.log(err);
			});
	};

	let mealNewid: any;
	let mealNewCreator: any;
	if (usersMeal.length > 0) {
		mealNewid = usersMeal.find((item: any, index: number) => {
			return item.status === 'new';
		})?.id;
		mealNewCreator = usersMeal.find((item: any, index: number) => {
			return item.status === 'new';
		})?.creator;
	}

	useEffect(() => {
		fetchAPI();
	}, []);

	const handleDeleteMeal = (record: any) => {
		setIsModalOpen(true);
		setInfoDeleteMeal(record);
	};

	const columns: ColumnsType<any> = [
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created',
			defaultSortOrder: 'descend',
		},
		{
			title: 'ID Bữa ăn',
			dataIndex: 'id',
			key: 'id',
			defaultSortOrder: 'descend',
			sorter: (a, b) => {
				return moment(a.id).valueOf() - moment(b.id).valueOf();
			},
		},
		{
			title: 'Người tạo',
			dataIndex: 'creator',
			key: 'creator',
		},
		{
			title: 'ID Người tạo',
			dataIndex: 'idCreator',
			key: 'idCreator',
		},
		{
			title: 'Người trả',
			dataIndex: 'payer',
			key: 'payer',
		},
		{
			title: 'Link cửa hàng',
			dataIndex: 'shoplink',
			key: 'shoplink',
			render: (_, record) => {
				return (
					<a href={record.shoplink} target="_blank" rel="noreferrer">
						{record.shoplink}
					</a>
				);
			},
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			key: 'status',

			render: (_, record) => {
				return (
					<p
						className={
							record.status == 'new'
								? 'red-character'
								: record.status == 'paid'
								? 'yellow-character'
								: record.status == 'deleted'
								? 'black-character'
								: 'green-character'
						}
					>
						{record.status == 'new'
								? 'Mới'
								: record.status == 'paid'
								? 'Đã thanh toán -  đang thu'
								: record.status == 'deleted'
								? 'Đã xoá'
								: 'Hoàn thành'}
					</p>
				);
			},
		},

		{
			title: 'Giá',
			dataIndex: 'shopprice',
			key: 'shopprice',
			render: (_, record) => {
				return <p>{record.shopprice} VND</p>;
			},
		},

		{
			title: 'Giá thực tế',
			dataIndex: 'totalneed2pay',
			key: 'totalneed2pay',
			render: (_, record) => {
				return <p>{record.totalneed2pay} VND</p>;
			},
		},
		{
			title: 'Chọn thực đơn',
			dataIndex: 'dishes',
			key: 'dishes',
			render: (_, record) => {
				return (
					<Button
						type="primary"
						onClick={() => {
							navigate(`/dish?&mealid=${record.id}`);
						}}
						disabled={record.status === 'deleted' || record.status === 'paid' || record.status === 'done'}
					>
						Chọn
					</Button>
				);
			},
		},
		{
			title: 'Xem lại danh sách món',
			dataIndex: 'dishes',
			key: 'dishes',
			render: (_, record) => {
				return (
					<Button
						type="primary"
						onClick={() => {
							navigate(`/dish?&mealid=${record.id}`);
						}}
						// disabled={record.status === 'deleted' || record.status === 'paid' || record.status === 'done'}
					>
						Xem
					</Button>
				);
			},
		},
		{
			title: 'Xóa bữa ăn',
			dataIndex: '',
			key: '',
			render: (_, record) => {
				return (
					<Button
						type="primary"
						onClick={() => {
							handleDeleteMeal(record);
						}}
						disabled={user.id !== record.idCreator || record.status === 'deleted'}
					>
						Xóa
					</Button>
				);
			},
		},
	];

	const realUsersMeal = usersMeal.map((item: any, index: number) => {
		return {
			created: moment(item.created).format('YYYY-MM-DD'),
			creator: userRender.find((itemChild: any, index: number) => {
				if (item.creator === itemChild.id) {
					return item;
				}
			})?.fullname,
			idCreator: item.creator,
			payer: userRender.find((itemChild: any, index: number) => {
				if (item.payer === itemChild.id) {
					return item;
				}
			})?.fullname,
			shoplink: item.shoplink,
			status: item.status,
			shopprice: formatMoney(item.shopprice),
			id: item.id,
			totalneed2pay: formatMoney(item.totalneed2pay),
		};
	});

	const handleOk = async () => {
		const paramsMeal = {
			shoplink: infoDeleteMeal.shoplink,
			shopprice: parseInt(infoDeleteMeal.shopprice.toString().replaceAll('.', '')),
			totalneed2pay: parseInt(infoDeleteMeal.totalneed2pay.toString().replaceAll('.', '')),
			creator: userRender.find((item: any, index: number) => {
				if (item.fullname === infoDeleteMeal.creator) {
					return item;
				}
			})?.id,
			payer: userRender.find((item: any, index: number) => {
				if (item.fullname === infoDeleteMeal.payer) {
					return item;
				}
			})?.id,
			status: 'deleted',
			created: moment(infoDeleteMeal.created).toISOString(),
			modified: moment(infoDeleteMeal.created).toISOString(),
		};
		console.log(paramsMeal);
		// return;
		await updateMeals(paramsMeal, infoDeleteMeal.id)
			.then(res => {
				// console.log(res);
				message.success('Bạn đã xóa thành công');
			})
			.catch(err => {
				// console.log(err);
				message.error('Bạn đã xóa thất bại');
			});
		await setIsModalOpen(false);
		await getMeals()
			.then((res: any) => {
				// console.log(res);
				setUsersMeal(res.data.result);
			})
			.catch((err: any) => {
				// console.log(err);
			});
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};
	return (
		<>
			<div className="text-center text-base ">
				<h1 className="my-5 text-lg">Chúc mọi người ăn trưa ngon miệng !</h1>
				<div className="w-full mx-auto  border border-gray-500 p-5  rounded-md form-order ">
					<div className="flex justify-evenly mb-5">
						<p className="mb-0 text-red-600">Người đăng nhập hiện tại: {user.fullname}</p>
						<Button
							type="primary"
							onClick={() => {
								navigate('/assume');
							}}
						>
							Thống kê
						</Button>
						<div>
							{usersMeal.some((item: any) => item.status === 'new') ? (
								<Button
									type="primary"
									onClick={() => {
										navigate('/order-edit?idMeal='+mealNewid);
									}}
									disabled={user.id!=mealNewCreator}
								>
									Sửa bữa ăn
								</Button>
							) : (
								<Button
									type="primary"
									className="mr-5"
									onClick={() => {
										navigate('/order-create');
									}}
								>
									Tạo bữa ăn
								</Button>
							)}
						</div>
					</div>
					<Table
						className="w-full"
						columns={columns}
						dataSource={realUsersMeal}
						pagination={false}
						scroll={{ y: 500 }}
						sortDirections={['descend', 'ascend', 'descend']}
					/>
				</div>
			</div>
			<Modal centered visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
				<p className="text-center">Bạn có đồng ý xóa bữa ăn này!</p>
			</Modal>
		</>
	);
}
